import { useAuth } from '../lib/auth';
import { useLang } from '../lib/lang';
import { toast } from 'sonner';
import { Share2, Copy } from 'lucide-react';

export default function ShareButtons({ raffleId, raffleTitle }) {
  const { user } = useAuth();
  const { t } = useLang();
  const siteUrl = window.location.origin;
  const shareUrl = `${siteUrl}/raffle/${raffleId}${user ? `?ref=${user.referral_code}` : ''}`;
  const text = `Check out this amazing draw: ${raffleTitle} on WINLUXOR!`;

  const handleShare = (platform) => {
    let url = '';
    switch (platform) {
      case 'whatsapp': url = `https://wa.me/?text=${encodeURIComponent(text + ' ' + shareUrl)}`; break;
      case 'twitter': url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareUrl)}`; break;
      case 'facebook': url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`; break;
      case 'instagram':
        navigator.clipboard.writeText(text + ' ' + shareUrl);
        toast.success(t('linkCopiedInstagram'));
        return;
      case 'copy':
        navigator.clipboard.writeText(shareUrl);
        toast.success(t('linkCopied'));
        return;
      default: break;
    }
    if (url) window.open(url, '_blank', 'width=600,height=400');
    toast.info(t('shareReferralInfo'));
  };

  return (
    <div className="space-y-2" data-testid="share-buttons">
      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground flex items-center gap-1"><Share2 className="w-3 h-3" /> {t('share')}:</span>
        <button onClick={() => handleShare('whatsapp')} className="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center text-xs font-bold hover:scale-110 transition-transform">W</button>
        <button onClick={() => handleShare('instagram')} className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 text-white flex items-center justify-center text-xs font-bold hover:scale-110 transition-transform">ig</button>
        <button onClick={() => handleShare('facebook')} className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold hover:scale-110 transition-transform">f</button>
        <button onClick={() => handleShare('twitter')} className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center text-xs font-bold hover:scale-110 transition-transform">X</button>
        <button onClick={() => handleShare('copy')} className="w-8 h-8 rounded-full bg-muted text-muted-foreground flex items-center justify-center hover:scale-110 transition-transform"><Copy className="w-3.5 h-3.5" /></button>
      </div>
      {user && <p className="text-[10px] text-muted-foreground">{t('shareEarnInfo')}</p>}
    </div>
  );
}
